<template>
  <div class="commonDialogBody">
     <PropertyTreeDialog @AllData="getMsgFormSon"  ref="PropertyTreeDialog" />
    <el-dialog
        :close-on-click-modal='false'
        :title="title"
         :visible.sync="dialogVisible"
        width="50%"
        :destroy-on-close="true"
        :before-close="handleClose">
        <div style="width:70%;margin-left:5%;">
<el-form :label-position="labelPosition" label-width="100px" :model="formLabelAlign" style="width:75%;" >
 <el-form-item label="归属机构" >
      <el-select  clearable v-model="value"     disabled placeholder="请选择（必填）" @change="handleChange">
    <el-option
      v-for="item in options"
      :key="item.officeId"
      :label="item.officeName"
      :value="item.officeId">
    </el-option>
  </el-select>
    <el-button @click="configuration()">配置</el-button>
      </el-form-item>
  <el-form-item label="物业类型" >
    <el-select  clearable v-model="valueone" placeholder="请选择物业类型"  size="small" @change="TenementType" >
        <el-option v-for="item in optionsone" :key="item.valueone" :label="item.labelone" :value="item.valueone"></el-option>
    </el-select>
  </el-form-item>
  <el-form-item label="项目代码" >
    <el-input v-model="formLabelAlign.code" size="small" placeholder="（必填）"></el-input>
  </el-form-item>
  <el-form-item label="项目名称">
    <el-input v-model="formLabelAlign.name" size="small" placeholder="（必填）"></el-input>
  </el-form-item>
    <el-form-item label="地址" >
      <el-input v-model="formLabelAlign.address" size="small"></el-input>
    </el-form-item>
    <el-form-item label="占地面积" >
     <el-input v-model="formLabelAlign.totalArea" size="small"></el-input>
    </el-form-item>
        <el-form-item label="建筑面积" >
     <el-input v-model="formLabelAlign.buildArea" size="small"></el-input>
    </el-form-item>
        <el-form-item label="公共场所面积" >
     <el-input v-model="formLabelAlign.publicArea" size="small"></el-input>
    </el-form-item>
        <el-form-item label="绿化面积" >
     <el-input v-model="formLabelAlign.virescenceArea" size="small"></el-input>
    </el-form-item>
        <el-form-item label="道路面积" >
     <el-input v-model="formLabelAlign.roadArea" size="small"></el-input>
    </el-form-item>
        <el-form-item label="地上停车面积" >
     <el-input v-model="formLabelAlign.upCarArea" size="small"></el-input>
    </el-form-item>
        <el-form-item label="地下停车面积" >
     <el-input v-model="formLabelAlign.downCarArea" size="small"></el-input>
    </el-form-item>
        <el-form-item label="地上车位数" >
     <el-input v-model="formLabelAlign.upCarNum" size="small"></el-input>
    </el-form-item>
        <el-form-item label="地下车位数" >
     <el-input v-model="formLabelAlign.downCarNum" size="small"></el-input>
    </el-form-item>
        <el-form-item label="开工日期" >
      <el-date-picker
      v-model="openDate"
      type="date"
      placeholder="选择日期"
      @change="openDateL()">
    </el-date-picker>
    </el-form-item>
        <el-form-item label="竣工日期" >
     <el-date-picker
      v-model="finishDate"
      type="date"
      placeholder="选择日期"
      @change="finishDateL()">
    </el-date-picker>
    </el-form-item>
        <el-form-item label="设计单位" >
     <el-input v-model="formLabelAlign.designCorp" size="small"></el-input>
    </el-form-item>
        <el-form-item label="开发单位" >
     <el-input v-model="formLabelAlign.developCorp" size="small"></el-input>
    </el-form-item>
        <el-form-item label="备注信息" >
     <el-input v-model="formLabelAlign.remarks" size="small"></el-input>
    </el-form-item>
</el-form>
</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="modification()" v-debounce>确 定 </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import PropertyTreeDialog from "../common/PropertyTreeDialog.vue";
export default {
 components: {PropertyTreeDialog},
  name: "PropertyDialog",
  data() {
    return {
      options:[],
      value: [],
     optionsone: [
       {valueone: '1',labelone: '住宅小区'}, {valueone: '2',labelone: '办公楼'},
      //           {valueone: '3',labelone: '商品房'}, {valueone: '4',labelone: '空房'},
      //           {valueone: '5',labelone: '售后公房'}, {valueone: '6',labelone: '售后公房（商）'},
      //           {valueone: '7',labelone: '联排别墅'}, {valueone: '8',labelone: '复式'},
      //           {valueone: '9',labelone: '联排'}, {valueone: '10',labelone: '公寓'},
      //           {valueone: '11',labelone: '独栋'}, {valueone: '12',labelone: '双拼'},
      //           {valueone: '13',labelone: '多层住宅'}, {valueone: '14',labelone: '高层住宅'},
      //           {valueone: '15',labelone: '商业用房'}, {valueone: '16',labelone: '办公用房'},
      //           {valueone: '17',labelone: '别墅'}, {valueone: '18',labelone: '商铺'},
      //           {valueone: '19',labelone: '写字楼'},
                ],
        value: '',
        valueone: '',
        dialogVisible: false,
        title:"标题",
        labelPosition:'right',
        formLabelAlign:{},
        type:"",
        display:"",
        detection:"",
        UserDisplay:"",
        openDate:"",
        finishDate:"",
        openDateTime:"",
        finishDateTime:"",
    };
  },
  watch:{
    dialogVisible(val){
      if(val == true){
        if(this.title == "添加"){
          this.formLabelAlign = {}
          this.valueone = ""
          this.value = ""
          this.finishDate = ""
          this.openDate = ""
        }else{
           let startDate = this.formLabelAlign.openDate.replace('T',' ')
          this.openDate = startDate.substr(0,startDate.length-9)
          let finishDate = this.formLabelAlign.finishDate.replace('T',' ')
          this.finishDate = finishDate.substr(0,finishDate.length-9)
        }
      }
    }
  },
  methods: {
    openDateL(){
      let date = this.openDate;
	    	let year = date.getFullYear();
	    	let month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1 ): date.getMonth() + 1
	    	let dates = date.getDate()< 10 ? '0' +date.getDate() : date.getDate()
            let time = year+"-"+month+"-"+dates
            this.openDateTime = time
    },
    finishDateL(){
      let date = this.finishDate;
	    	let year = date.getFullYear();
	    	let month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1 ): date.getMonth() + 1
	    	let dates = date.getDate()< 10 ? '0' +date.getDate() : date.getDate()
            let time = year+"-"+month+"-"+dates
            this.finishDateTime = time
    },
    configuration(){
      this.$refs.PropertyTreeDialog.title = "配置";
      this.$refs.PropertyTreeDialog.dialogVisi = true;
    },
      handleChange(value){
      },
      TenementType(valueone){
      },
    modification(){
        if(this.title == "修改"){
            let obj = {
                "orgCode":this.valueone, // 物业类型
                "name":this.formLabelAlign.name, // 项目名称
                "code":this.formLabelAlign.code, // 项目代码
                "orgId":this.formLabelAlign.orgId, // 归属机构
                "address":this.formLabelAlign.address, // 项目地址
                "totalArea":this.formLabelAlign.totalArea, // 占地面积
                "virescenceArea":this.formLabelAlign.virescenceArea, // 绿化面积
                "buildArea":this.formLabelAlign.buildArea, // 建筑面积
                "publicArea":this.formLabelAlign.publicArea, // 公共面积
                "roadArea":this.formLabelAlign.roadArea, // 道路面积
                "upCarArea":this.formLabelAlign.upCarArea, // 地上停车场面积
                "downCarArea":this.formLabelAlign.downCarArea,//  	地下停车场面积
                "upCarNum":this.formLabelAlign.upCarNum*1,//  	地上停车位
                "downCarNum":this.formLabelAlign.downCarNum*1,// 地下停车位
                "openDate":this.openDateTime,//  开工日期
                "finishDate": this.finishDateTime,// 竣工日期
                "designCorp":this.formLabelAlign.designCorp,// 	设计单位
                "developCorp":this.formLabelAlign.developCorp,// 开发单位
                "id":this.formLabelAlign.id,// 
                "remarks":this.formLabelAlign.remarks,// 备注
            }
            this.$http.put(this.$requestUrl.PUT_PROJECT_AMEND,obj).then((res) => {
            let result = res.data;
            if (200 === result.code) {
              this.dialogVisible = false
              this.$emit("Visible",false)
            } else {
              this.$message.error(result.msg)
            }
            }).catch(() => {
              this.$message.error(this.$errorMessage.SEVER_ERROR)
            })
        }else{
              let obj = {
                "orgCode":this.valueone, // 物业类型
                "name":this.formLabelAlign.name, // 项目名称
                "code":this.formLabelAlign.code, // 项目代码
                "orgId":this.value, //归属机构
                "address":this.formLabelAlign.address, // 项目地址
                "totalArea":this.formLabelAlign.totalArea, // 占地面积
                "virescenceArea":this.formLabelAlign.virescenceArea, // 绿化面积
                "buildArea":this.formLabelAlign.buildArea, // 建筑面积
                "publicArea":this.formLabelAlign.publicArea, // 公共面积
                "roadArea":this.formLabelAlign.roadArea, // 道路面积
                "upCarArea":this.formLabelAlign.upCarArea, // 地上停车场面积
                "downCarArea":this.formLabelAlign.downCarArea,//  	地下停车场面积
                "upCarNum":this.formLabelAlign.upCarNum*1,//  	地上停车位
                "downCarNum":this.formLabelAlign.downCarNum*1,// 地下停车位
                "openDate":this.openDateTime,//  开工日期
                "finishDate": this.finishDateTime,// 竣工日期
                "designCorp":this.formLabelAlign.designCorp,// 	设计单位
                "developCorp":this.formLabelAlign.developCorp,// 开发单位
                "remarks":this.formLabelAlign.remarks,// 备注
            }
            console.log(obj)
            if(obj.name != undefined || obj.name != undefined || obj.name != ''){
              if(obj.code != undefined || obj.code != undefined || obj.code != ''){
                if(obj.orgid != undefined || obj.orgid != undefined || obj.orgid != ''){
                   this.$http.post(this.$requestUrl.POST_PROJECT_ADD,obj).then((res) => {
              let result = res.data;
              if (200 === result.code) {
                this.dialogVisible = false
                this.$emit("Visible",false)
              } else {
                this.$message.error(result.msg)
              }
              }).catch(() => {
                this.$message.error(this.$errorMessage.SEVER_ERROR)
              })
                }else{
                  this.$message({
                    message: '请选择归属机构！',
                    type: 'warning'
                  });
                }
              }else{
                 this.$message({
                    message: '请填写项目代码！',
                    type: 'warning'
                  });
              }
            }else{
              this.$message({
                message: '请填写项目名称！',
                type: 'warning'
              });
            }

        }

    },

    getMsgFormSon(data){
      let arr = []
      for(let val of data){
        // console.log(val)
        if(val.children.length>0){
          this.value = val.officeId
          arr.push(val)
        }else{
          this.value = val.officeId
          delete val.children
          arr.push(val)
        }

        // delete val.children
      }
        // console.log(arr)
        
        this.options = arr
    },
    handleClose(done) {
     this.dialogVisible = false
    },
    amend(){
    }
  },
    //组件创建之后
  created() {

  },
    //页面渲染之前
  beforeMount() {
            if(this.formLabelAlign.obj == undefined){
                   let obj = {
            "areaname":"归属机构",
            "orgCode":"物业类型",
            "code":"项目代码",
            "name":"项目名称",
            "site":"地址",
            "floor":"占地面积",
            "buildArea":"建筑面积",
            "public":"公共场所面积",
            "afforest":"绿化面积",
            "way":"道路面积",
            "groundarea":"地上停车面积",
            "undergroundarea":"地下停车面积",
            "groundCar":"地上车位数",
            "undergroundCar":"地下车位数",
            "start":"开工日期",
            "userType":"竣工日期",
            "design":"设计单位",
            "exploit":"开发单位",
            "remarks":"备注信息",
          }
          this.osData = []
      this.formLabelAlign.obj = obj
    }
  },
}
</script>

<style scoped lang="scss">
// .commonDialogBody {

// }
</style>